export default __webpack_public_path__ + "static/media/chainlink.bff9e884.svg";